import React, { useRef, useEffect, useState } from 'react'
import RichTextHeader from './RichTextHeader'

interface RichTextProps {
    value?: string
    onChange: (value: string) => void
    placeholder?: string
}

const RichText: React.FC<RichTextProps> = ({ value = '', onChange, placeholder = 'Digite seu texto aqui...' }) => {
    const editorRef = useRef<HTMLDivElement>(null)
    const [isEmpty, setIsEmpty] = useState(!value)

    useEffect(() => {
        if (editorRef.current && editorRef.current.innerHTML !== value) {
            editorRef.current.innerHTML = value
            setIsEmpty(!value || value === '<br>') // Considera '<br>' como vazio
        }
    }, [value])

    const applyFormatting = (command: string, commandValue: string = '') => {
        document.execCommand(command, false, commandValue)
        const currentContent = editorRef.current?.innerHTML || ''
        onChange(currentContent)
        setIsEmpty(!currentContent || currentContent.toLowerCase() === '<br>')
    }

    const handleInput = () => {
        const currentContent = editorRef.current?.innerHTML || ''
        onChange(currentContent)
        setIsEmpty(!currentContent || currentContent.toLowerCase() === '<br>') // Considera '<br>' como vazio
    }

    return (
        <div className='dark:text-gray-200 relative'>
            <RichTextHeader onFormat={applyFormatting} />
            <div
                ref={editorRef}
                contentEditable
                className='w-full min-h-[100px] overflow-auto mt-1 p-2 border dark:bg-gray-800 dark:border-gray-700 rounded-lg outline-none focus:outline-none text-left text-sm'
                onInput={handleInput}
                suppressContentEditableWarning={true}
                dir='ltr'
            />
            {isEmpty && placeholder && (
                <div className='absolute top-[49px] left-[12px] text-gray-500 pointer-events-none dark:text-gray-600 text-sm'>
                    {placeholder}
                </div>
            )}
        </div>
    )
}

export default RichText
